import React from "react";
import Container from "../../components/Container/Container";
import { tableRegistryEntries } from "../../components/Tables/tableRegistry";
import "./devtablespage.scss";

const DevTablesPage: React.FC = () => {
  return (
    <Container type="wide">
      <div className="dev-tables-page">
        <div className="dev-tables-page__intro">
          <h1>Tables preview</h1>
          <p>
            Central preview of all registered table renderers used across the content JSON files.
          </p>
        </div>

        <div className="dev-tables-page__grid">
          {tableRegistryEntries.map((entry) => (
            <section key={entry.type} className="dev-tables-page__card">
              <div className="dev-tables-page__card-header">
                <div>
                  <h2>{entry.title}</h2>
                  <p>{entry.type}</p>
                </div>
                <span className={`dev-tables-page__badge dev-tables-page__badge--${entry.source}`}>
                  {entry.source}
                </span>
              </div>
              <div className="dev-tables-page__table">{entry.render()}</div>
            </section>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default DevTablesPage;
